export const TOGGLE_AR_DASHBOARD_LOADING = 'TOGGLE_AR_DASHBOARD_LOADING'

export const toggleARDashboardLoading = (on) => ({
  type: TOGGLE_AR_DASHBOARD_LOADING,
  on,
})
